import app from './../app.js';  
import config from './../config.js';  
import Base_tools_class from './../core/base-tools.js';  
import Base_layers_class from './../core/base-layers.js';  
import Dialog_class from './../libs/popup.js';  
import Helper_class from './../libs/helpers.js';  

class PanelClass
{
    constructor() 
    {
        this.POP = new Dialog_class();
        this.Base_layers = new Base_layers_class();
        this.Helper = new Helper_class();
        this.name = 'panel';  
    }
   
    // Add to PanelClass  
    static syncColorProperties(layer) 
    {  
        if (layer.type === 'rectangle' && layer.params) {  
            // Sync from color to params  
            if (layer.color && layer.color !== layer.params.fill_color) {  
                layer.params.fill_color = layer.color;  
                
            }  
            // Sync from params to color  
            else if (layer.params.fill_color && layer.params.fill_color !== layer.color) {  
                layer.color = layer.params.fill_color;  
            }  
        }  
    }
    
    on_params_update(param) 
    {  
        const { key, value } = param;  
        const layer = config.layer;  

        if (layer && layer.type === 'rectangle') {  
            let params = { ...layer.params };  
            params[key] = value;  

            app.State.do_action(  
                new app.Actions.Update_layer_action(layer.id, {  
                    params: params  
                })  
            );  
        }  
        if (param.key === 'opacity') 
        {  
            // Update the current layer's opacity  
            app.State.do_action(  
                new app.Actions.Update_layer_action(config.layer.id, {  
                    opacity: param.value  
                })  
            );  
        }  
        if (param.key === 'fill_color') 
        {  
            // Update the current layer's opacity  
            app.State.do_action(  
                new app.Actions.Update_layer_action(config.layer.id, {  
                    fill_color: param.value, 
                    color: param.value
                })  
            );  
        }  
    }
    on_activate() 
    {  
        // Skip if layers aren't fully initialized yet  
        if (!config.layers || config.layers.length === 0) 
        {  
            return;  
        }  
          // Only show dialog if current layer is not already a panel  
        if (!config.layer || config.layer.type !== 'rectangle') {  
            this.show_dialog();  
        }
    }
    show_dialog()
    {
        const settings = {
            title: 'Panel Creation Settings',
            preview: false,
            params: [
                { name: "color_param", title: "Color:", value: "#ff0000", type: "color" },
                {
                    name: "radio_param",
                    title: "Mode:",
                    value: "Horizontal",
                    values: ["Horizontal", "Vertical", "Free-form"]
                }
            ],
            on_finish: (params) => {
                // final apply
                

                // Get canvas dimensions from config  
                let width;  
                let height;
                if(params.radio_param == "Horizontal")
                {
                    width = config.WIDTH;
                    height = 100;
                }
                else if(params.radio_param == "Vertical")
                {
                    width = 100;
                    height = config.HEIGHT;
                }
                else
                {
                    width = 100;
                    height = 100;
                }
                
                let color = params.color_param || "#ff0000";  
                // Replace the placeholder layer
                let layerParams = {
                    type: 'rectangle',
                    name: 'Panel',
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                    opacity: 50,
                    color: color, 
                    params: 
                    {                    // ← Colors go here  
                        fill: true,  
                        border: false,  
                        fill_color: color,  
                        radius: 0,
                    },  
                    render_function: ["rectangle", "render"]  // Add this line  
                };
                app.State.do_action(
                    new app.Actions.Insert_layer_action(layerParams)
                );
            
        }
    };
        this.POP.show(settings);
    }
}

export default PanelClass;